// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.full-height {
  display: block;
  text-align: center; /* pour centrer le contenu */
  padding: 20px; /* pour un peu d'espacement */
}

.header, .button-container {
  text-align: right; /* pour aligner le bouton de fermeture et les boutons d'action à droite */
}

.spacer {
  height: 50px; /* ajustez en fonction de vos besoins */
}

.center-text {
  margin: 20px 0; /* ajustez en fonction de vos besoins */
}

.input-container {
  margin: 20px 0; /* ajustez en fonction de vos besoins */
}`, "",{"version":3,"sources":["webpack://./src/app/+home/+my-libraries/+sites/config-site/dialog-confirm-delete-site/dialog-confirm-delete-site.component.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACI,cAAA;EACA,kBAAA,EAAA,4BAAA;EACA,aAAA,EAAA,6BAAA;AAEJ;;AACA;EACI,iBAAA,EAAA,yEAAA;AAEJ;;AACA;EACI,YAAA,EAAA,uCAAA;AAEJ;;AACA;EACI,cAAA,EAAA,uCAAA;AAEJ;;AACA;EACI,cAAA,EAAA,uCAAA;AAEJ","sourcesContent":[".full-height {\r\n    display: block;\r\n    text-align: center; /* pour centrer le contenu */\r\n    padding: 20px; /* pour un peu d'espacement */\r\n}\r\n\r\n.header, .button-container {\r\n    text-align: right; /* pour aligner le bouton de fermeture et les boutons d'action à droite */\r\n}\r\n\r\n.spacer {\r\n    height: 50px; /* ajustez en fonction de vos besoins */\r\n}\r\n\r\n.center-text {\r\n    margin: 20px 0; /* ajustez en fonction de vos besoins */\r\n}\r\n\r\n.input-container {\r\n    margin: 20px 0; /* ajustez en fonction de vos besoins */\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
